module.exports = "<app-header></app-header>\r\n<main class=\"detalle\">\r\n  <div class=\"breadcrumb-class\"></div>\r\n  <div class=\"container-fluid\">\r\n      <router-outlet></router-outlet>\r\n  </div>\r\n  <!--<app-rmenu></app-rmenu>-->\r\n</main>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main